import { CommandEnum } from '@/types/schema';

import { ContentViewProgressMutationVariables } from '../../graphql/mutations/generated/contentViewProgress';
import { Params } from './types';

const getContentViewProgressMutationVariables = (
  params: Params,
): ContentViewProgressMutationVariables => {
  const { entityId, resume, parentEntityId, isContentVisited, isSetView } = params;

  const input: ContentViewProgressMutationVariables['input'] = [];

  const setViewInput = {
    command: CommandEnum.SetView,
    clientTimestamp: new Date().toISOString(),
    entityId,
    resume,
    parentEntityId,
  };

  const contentVisitedInput = {
    entityId,
    command: CommandEnum.ContentVisit,
    clientTimestamp: new Date().toISOString(),
  };

  if (isSetView) {
    input.push(setViewInput);
  }

  if (isContentVisited) {
    input.push(contentVisitedInput);
  }

  return {
    input,
  };
};

export { getContentViewProgressMutationVariables };
